const ERRORS = {
    REQUIRED: 'This field is required.',
    INVALID_CCNUMBER: 'Please enter a valid Card Number.',
}

export {
    ERRORS,
}


// WEBPACK FOOTER //
// ./src/components/billing-form/constants/errors.js